module.exports = __webpack_public_path__ + "img/pic_our_city_S.467c474c.jpg";